import React from 'react';
import styles from './LabelText.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const LabelText = ({text, className}) => {
  return (
    <p className={`${cx('LabelText')} ${className}`}>{text}</p>
  );
};

LabelText.defaultProps = {
  className:''
}

export default LabelText;